import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { WorkOrder } from "../../shared/interfaces/WorkOrder";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useUpdateWorkOrder(callbacks?: QueryCallbacks<void>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["updateWorkOrder"],
    async (workorder: WorkOrder) => apiContext.workOrderApis.updateWorkorder(workorder),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
